<template>
  <Modal
      v-model="visible"
      title="新增注入对象"
      :width="600"
      :mask-closable="false"
      >
      <Form  :label-width="100">
        <FormItem label="父进程">
        <Select style="width:140px;" v-model="parentProVal">
          <Option v-for="(item, index) in perPoress" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
        <Input v-if="parentProVal != 'null'" v-model="parentVal" class="margin6" :class="{ error: parentError }"
          style="width:300px;margin-left: -1px;" :placeholder="parentPsw"></Input>
      </FormItem>
      <FormItem label="子进程">
        <Select style="width:140px;" v-model="childProVal">
          <Option v-for="(item, index) in perPoress" v-show="index != 0" :value="item.value" :key="index">{{
              item.label
          }}</Option>
        </Select>
        <Input style="width:300px;margin-left: -1px;" :class="{ error: childrenError }" v-model="childVal"
          :placeholder="childPsw"></Input>
      </FormItem>
      <FormItem label="匹配子进程级数" class="">
        <Checkbox border class="checkBg " v-model="matchProc" >匹配子进程</Checkbox>
        <InputNumber style="width:100px;"  v-if="matchProc" :min="0" :max="65534" :class="{ error: childNumEro }" v-model="childNum"
          placeholder="1~65534代表父进程的第几个子进程" />
      </FormItem>
      </Form>
      <p class="errorCol" style="padding-left:80px;padding-bottom:10px;">{{ errorMsg }}</p>
      <div slot="footer">
          <Button    @click="cancelFn">取消</Button>
          <Button type="primary"   @click="okFn">确定</Button>
      </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      parentProVal: 'Name',
      parentVal: '',
      childProVal: 'Name',
      childVal: '',
      childrenError: '',
      childNumEro: '',
      childNum: 0,
      matchProc: 0,
      perPoress: [
        {
          label: '任意进程',
          value: 'null'
        },
        {
          label: '进程名称',
          value: 'Name'
        },
        {
          label: '进程路径',
          value: 'Path'
        },
        {
          label: '进程MD5码',
          value: 'MD5'
        },
        {
          label: '文件特征码（Hash）',
          value: 'Hash'
        },
        {
          label: '文件数字签名序列号',
          value: 'Sign'
        }
      ],
      parentPsw: '支持进程名称，通配符*和?，以及null',
      childPsw: '支持进程名称，通配符*和?，以及null',
      parentError: false,
      errorMsg: ''
    }
  },
  watch: {
    parentProVal () {
      this.passWord(this.parentProVal, 1)
    },
    childProVal () {
      this.passWord(this.childProVal, 2)
    },
    visible() {
      this.erroInit()
      this.parentVal = ''
      this.childVal = ''
    }
  },
  methods: {
    passWord (type, key) {
      switch (type) {
        case 'null':
          if (key == 1) {
            this.parentPsw = ''
          } else {
            this.childPsw = ''
          }
          break
        case 'Name':
          if (key == 1) {
            if (this.type == 5 || this.type == 2) {
              this.parentPsw = '支持模块名称，通配符*和?，以及null'
            } else if (this.type == 13 || this.type == 6) {
              this.parentPsw = '支持驱动名称，通配符*和?，以及null'
            } else if (this.type == 1) {
              this.parentPsw = '支持文件名称，通配符*和?，以及null'
            } else if (this.type == 4) {
              this.parentPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
            } else {
              this.parentPsw = '支持进程名称，通配符*和?，以及null'
            }
          } else {
            if (this.type == 5 || this.type == 2) {
              this.childPsw = '支持模块名称，通配符*和?，以及null'
            } else if (this.type == 13 || this.type == 6) {
              this.childPsw = '支持驱动名称，通配符*和?，以及null'
            } else if (this.type == 1) {
              this.childPsw = '支持文件名称，通配符*和?，以及null'
            } else if (this.type == 4) {
              this.childPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
            } else {
              this.childPsw = '支持进程名称，通配符*和?，以及null'
            }
          }
          break
        case 'Path':
          if (key == 1) {
            this.parentPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
          } else {
            this.childPsw = '支持以\\开头且以*或\\结尾的进程路径，通配符*和?，以及null'
          }
          break
        case 'MD5':
          if (key == 1) {
            this.parentPsw = '支持32位大小写字母数字，不支持通配符'
          } else {
            this.childPsw = '支持32位大小写字母数字，不支持通配符'
          }
          break
        case 'Hash':
          if (key == 1) {
            this.parentPsw = '8位大小写字母数字，不支持通配符'
          } else {
            this.childPsw = '8位大小写字母数字，不支持通配符'
          }
          break
        case 'Sign':
          if (key == 1) {
            this.parentPsw = '20位或32位或38位大小写字母数字，不支持通配符和空格'
          } else {
            this.childPsw = '20位或32位或38位大小写字母数字，不支持通配符和空格'
          }
          break
        case 'SignName':
          if (key == 1) {
            this.parentPsw = '最大64位字符及除了通配符*和?之外的所有字符'
          } else {
            this.childPsw = '最大64位字符及除了通配符*和?之外的所有字符'
          }
          break
        case 'cmdline':
          this.parentPsw = '请输入命令行文本'
          break
        default:
          break
      }
    },
    erroInit () {
      this.errorMsg = ''
      this.parentError = false
      this.childrenError = false
      this.childNumEro = false
    },
    okFn() {
      var parentPath, selfPath
      if (this.parentProVal == 'null') {
        parentPath = 0
      } else if (this.parentProVal == 'Name') {
        parentPath = 1
      } else if (this.parentProVal == 'Path') {
        parentPath = 1
      } else if (this.parentProVal == 'MD5') {
        parentPath = 2
      } else if (this.parentProVal == 'Hash') {
        parentPath = 3
      } else if (this.parentProVal == 'Sign') {
        parentPath = 4
      }
      if (this.childProVal == 'null') {
        selfPath = 0
      } else if (this.childProVal == 'Name') {
        selfPath = 1
      } else if (this.childProVal == 'Path') {
        selfPath = 1
      } else if (this.childProVal == 'MD5') {
        selfPath = 2
      } else if (this.childProVal == 'Hash') {
        selfPath = 3
      } else if (this.childProVal == 'Sign') {
        selfPath = 4
      }
      if (this.parentProVal != 'null') {
        // this.errorMsg = '请输入进程信息'
        let msg = this.$validateCenter.checkPro(this.parentProVal, this.parentVal)
        if (msg != '') {
          this.erroInit()
          this.errorMsg = msg + ':' + this.parentPsw
          this.parentError = true
          return
        }
      } else {
        this.parentVal = null
      }
      let msg = this.$validateCenter.checkPro(this.childProVal, this.childVal)
      if (msg != '') {
        this.erroInit()
        this.errorMsg = msg + ':' + this.childPsw
        this.childrenError = true
        return
      }
      // console.log(this.parentProVal, this.parentVal, this.childProVal, this.childVal)
      if (parentPath != 0) {
        if (!this.$validateCenter.isHashLine(this.parentVal)) {
          if (!this.$validateCenter.isRouteHas(this.parentVal)) {
            this.parentVal = '*\\' + this.parentVal
          }
        }
      }
      if (!this.$validateCenter.isHashLine(this.childVal)) {
        if (!this.$validateCenter.isRouteHas(this.childVal)) {
          this.childVal = '*\\' + this.childVal
        }
      }
      let json = {
        parentProcType: parentPath,
        parentProcValue: this.parentVal,
        childProcType: selfPath,
        childProcValue: this.childVal,
        procLevel: this.childNum
      }
      this.$emit('addJson', json)
      this.visible = false
      this.fileVisible = false
    },
    cancelFn() {
      this.visible = false
    },
  }
}
</script>